import React from 'react';
import ReactNative from './base_components';

import util from '../tools/util';

const { StyleSheet, View, Image, Text } = ReactNative;

const styles = StyleSheet.create({
  coinPrice: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '2em',
    height: '2em',
  },
  text: {
    marginLeft: '1em',
    marginTop: '0.4em',
    color: 'white',
    fontSize: '1.1em',
  },
  largeImage: {
    width: '4em',
    height: '4em',
  },
  largeText: {
    marginLeft: '1em',
    marginTop: '0.4em',
    color: 'white',
    fontSize: '1.5em',
  },
});

const COIN_IMG = require('../assets/img/dank_coin.png');
const ANIMATED_IMG = require('../assets/img/dank_coin.gif');

type Props = {
  style?: any;
  price: number;
  size?: string;
  animated?: boolean;
};
export default class CoinPrice extends React.PureComponent<Props> {
  render() {
    const { style, price, animated, size } = this.props;

    let img_src = COIN_IMG;
    if (animated) {
      img_src = ANIMATED_IMG;
    }

    let content = null;
    if (size === 'large') {
      content = (
        <View style={[styles.coinPrice, style]}>
          <Image
            style={styles.largeImage}
            resizeMode='contain'
            source={img_src}
          />
          <Text style={styles.largeText}>{util.doubleToString(price)}</Text>
        </View>
      );
    } else {
      content = (
        <View style={[styles.coinPrice, style]}>
          <Image style={styles.image} resizeMode='contain' source={img_src} />
          <Text style={styles.text}>{util.doubleToString(price)}</Text>
        </View>
      );
    }

    return content;
  }
}
